"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Header = () => {
  const pathname = usePathname();
  const isMarketingCampain =
    pathname === "/smapplications" || pathname === "/formcandidates";

  return (
    <>
      <nav
        className={`navbar fixed right-0 left-0 top-0 px-5 lg:px-24 transition-all duration-500 ease shadow-lg shadow-gray-200/20 bg-white border-gray-200 z-40 ${isMarketingCampain ? 'py-4' : ''}`}
        id="navbar"
      >
        <div className="mx-auto container-fluid">
          <div className="flex flex-wrap items-center justify-between mx-auto">
            <div className="flex items-center">
              <Image
                src="/assets/images/logo.png"
                alt=""
                className="logo-dark block dark:hidden"
                width={150}
                height={70}
              />
              <Image
                src="/assets/images/logo.png"
                alt=""
                className="logo-dark hidden dark:block"
                width={150}
                height={70}
              />
            </div>

            {!isMarketingCampain && (
              <>
                <div suppressHydrationWarning
                  id="navbar-collapse"
                  className="navbar-res items-center justify-between w-full text-sm lg:flex lg:w-auto lg:order-1 group-focus:[.navbar-toggler]:block hidden"
                >
                  <ul
                    className="flex flex-col items-start mt-5 mb-10 font-medium lg:mt-0 lg:mb-0 lg:items-center lg:flex-row"
                    id="navigation-menu"
                  >
                    <li className="relative dropdown">
                      <Link
                        href="/"
                        className="py-5 text-gray-700 lg:px-4 dropdown-toggle lg:h-[70px]"
                      >
                        Home{" "}
                        <i className="align-middle bx bxs-chevron-down ltr:ml-1 rtl:mr-1"></i>
                      </Link>
                    </li>
                    {/* Company dropdown removido conforme requisito */}
                    {false && (
                      <li className="relative dropdown lg:mt-0">REMOVED</li>
                    )}
                    <li className="relative dropdown lg:mt-0">
                      <Link
                        href="/jobs"
                        className="py-5 text-gray-700 lg:px-4 dropdown-toggle lg:h-[70px]"
                      >
                        Jobs{" "}
                        <i className="align-middle bx bxs-chevron-down ltr:ml-1 rtl:mr-1"></i>
                      </Link>
                    </li>
                    <li className="relative dropdown lg:mt-0">
                      <Link
                        href="/signup"
                        className="py-5 text-gray-700 lg:px-4 dropdown-toggle lg:h-[70px]"
                      >
                        Sign Up Candidates{" "}
                        <i className="align-middle bx bxs-chevron-down ltr:ml-1 rtl:mr-1"></i>
                      </Link>
                    </li>
                    <li className="py-5 lg:px-4">
                      <a
                        href="https://www.hgstaffingsolutions.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="py-5 text-gray-700 lg:px-4 dropdown-toggle lg:h-[70px] hover:underline"
                      >
                        Contact{" "}
                        <i className="align-middle bx bxs-chevron-down ltr:ml-1 rtl:mr-1"></i>
                      </a>
                    </li>
                    {/* Customer Portal button removed - no longer needed */}
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
